import { marketplaceApi, pollOrderUntilSettled, type CheckoutPlatform } from '../../api/marketplace';
import { ApiError } from '../../lib/api';
import { haptic, hapticPaySuccess, openCheckoutLink, openInvoice } from '../../lib/telegram';

export type PayResult = 'paid' | 'failed' | 'cancelled' | 'pending';

export async function payItems(
  items: Array<{ productId: string; quantity: number; topUpAmount?: number; editionId?: string }>,
  platform: CheckoutPlatform,
): Promise<{ result: PayResult; orderId: string }> {
  const order = await marketplaceApi.checkout(items, platform);

  if (!order.invoiceUrl) {
    throw new Error('Провайдер не вернул ссылку на оплату');
  }

  if (order.paymentKind === 'tribute-webapp') {
    openCheckoutLink(order.invoiceUrl);
    const settled = await pollOrderUntilSettled(order.orderId);

    if (settled.status === 'DELIVERED') return { result: 'paid', orderId: order.orderId };
    if (settled.status === 'FAILED' || settled.status === 'CANCELLED') return { result: 'failed', orderId: order.orderId };
    return { result: 'pending', orderId: order.orderId };
  }

  const status = await openInvoice(order.invoiceUrl);

  if (status === 'cancelled') {
    await marketplaceApi.cancelOrder(order.orderId).catch(() => undefined);
  }

  return { result: status, orderId: order.orderId };
}

export function payErrorMessage(cause: unknown): string {
  if (cause instanceof ApiError && cause.code === 'OUT_OF_STOCK') return 'Товар только что закончился';
  if (cause instanceof Error) return cause.message;
  return 'Не удалось оформить заказ';
}

export function notifyPayResult(result: PayResult): string | null {
  if (result === 'paid') {
    hapticPaySuccess();
    return null;
  }

  if (result === 'failed') {
    haptic('error');
    return 'Платёж не прошёл';
  }

  if (result === 'pending') {
    haptic('warning');
    return 'Если списал — ключ появится в Инвентаре через минуту';
  }

  return null;
}
